import { render, staticRenderFns } from "./VerAlertaModal.vue?vue&type=template&id=c4a76840&"
import script from "./VerAlertaModal.vue?vue&type=script&lang=ts&"
export * from "./VerAlertaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports